import React from "react";
import useSiteData from '../../useSiteData'
import SocialMedia from "../molecules/SocialMedia";

export default ({ className, socialMedia, isRound }) => {
    socialMedia = socialMedia || useSiteData().pageSettings.footerSocialMediaLinks;

    return (
        <ul className="o-social-media-list u-list-unstyled">
            { socialMedia.map(({ link, socialMediaTitle }, index) =>
                <li className="o-social-media-list__item" key={ index }>
                    <SocialMedia
                        className={ className }
                        url={ link }
                        title={ socialMediaTitle }
                        isRound={ isRound }
                    />
                </li>
            ) }
        </ul>
    );
}
